import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from './firebaseConfig';

export const resolveTrackUrl = (path: string): Promise<string> => {
  return getDownloadURL(ref(storage, path));
};
